

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: false,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":{"pt":["pt-PT"],"default":["en-GB"]}},
  vueI18nLoader: false,
  locales: [{"code":"en-GB","file":"en-GB.json","name":"English (United Kingdom)"},{"code":"pt-PT","file":"pt-PT.json","name":"Português"}],
  defaultLocale: "en-GB",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "no_prefix",
  lazy: true,
  langDir: "/frontend/locales",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":true,"fallbackLocale":"","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"en-GB","file":"en-GB.json","name":"English (United Kingdom)"},{"code":"pt-PT","file":"pt-PT.json","name":"Português"}],
  localeCodes: ["en-GB","pt-PT"],
  additionalMessages: [],
}

export const localeMessages = {
  'en-GB.json': () => import('../../locales/en-GB.json' /* webpackChunkName: "lang-en-GB.json" */),
  'pt-PT.json': () => import('../../locales/pt-PT.json' /* webpackChunkName: "lang-pt-PT.json" */),
}
